import { render, staticRenderFns } from "./settingsSubscriptions.vue?vue&type=template&id=103214be&scoped=true&"
import script from "./settingsSubscriptions.vue?vue&type=script&lang=js&"
export * from "./settingsSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./settingsSubscriptions.vue?vue&type=style&index=0&id=103214be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103214be",
  null
  
)

export default component.exports